/**
 * QorTrace · Landing — Iter239
 *
 * A small, deliberate visual punctuation between major landing
 * sections. The page had become a long stack of left-aligned text
 * blocks that ran together — there was nothing to tell the eye
 * "section ended, next section starts." This component is that
 * anchor.
 *
 * Renders a faint horizontal gradient line with a small cyan
 * diamond at the center. Aria-hidden — purely visual.
 */
import React from "react";


export default function SectionPunctuator() {
  return (
    <div
      aria-hidden="true"
      data-testid="section-punctuator"
      className="flex items-center justify-center"
      style={{
        maxWidth: 1400,
        margin: "32px auto",
        padding: "0 24px",
        gap: 14,
      }}
    >
      <span
        style={{
          flex: 1, height: 1,
          background:
            "linear-gradient(to right, transparent, rgba(0,229,255,0.18) 50%, transparent)",
        }}
      />
      <svg width="10" height="10" viewBox="0 0 10 10" aria-hidden="true">
        <rect
          x="5" y="0.5"
          width="6.36" height="6.36"
          fill="#00E5FF"
          transform="rotate(45 5 5)"
          opacity="0.55"
        />
      </svg>
      <span
        style={{
          flex: 1, height: 1,
          background:
            "linear-gradient(to left, transparent, rgba(0,229,255,0.18) 50%, transparent)",
        }}
      />
    </div>
  );
}
